// extracted by mini-css-extract-plugin
export default {"container":"rem_lsabc","card":"rem_car_3yLjk"};